import { render } from "./ListRomb.vue?vue&type=template&id=0ccb022a&scoped=true"
import script from "./ListRomb.vue?vue&type=script&lang=js"
export * from "./ListRomb.vue?vue&type=script&lang=js"

import "./ListRomb.vue?vue&type=style&index=0&id=0ccb022a&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ccb022a"]])

export default __exports__